import baseUrl from "../energyApiHost";
import dingoBaseUrl from "../dingoApiHost";
import { callApi } from "./util";
import moment from "moment";

const getData = (sensorId, dataResolution, from, to) => {
  const convertDate = date =>
    moment(date)
      .utc()
      .format("YYYYMMDDHHmmss");

  let url = `${baseUrl}sensors/${sensorId}/data?from=${convertDate(
    from
  )}&resolution=${dataResolution}`;

  if (to) {
    url += `&to=${convertDate(to)}`;
  }

  return callApi(url);
};

const getDataFromDingo = (
  dingoId,
  dataResolution,
  from,
  to,
  convertToNonCumulative
) => {
  const convertDate = date =>
    moment(date)
      .utc()
      .format("YYYYMMDDHHmmss");

  let url = `${dingoBaseUrl}sensors/${dingoId}/data?from=${convertDate(
    from
  )}&resolution=${dataResolution}`;

  if (to) {
    url += `&to=${convertDate(to)}`;
  }

  if (convertToNonCumulative) {
    url += `&convertToNonCumulative=${convertToNonCumulative}`;
  }
  return callApi(url);
};

const getLightsOverThresholdAlertThrehsolds = (sensorId, from, to) => {
  const convertDate = date =>
    moment(date)
      .utc()
      .format("YYYYMMDDHHmmss");

  const url = `${baseUrl}sensors/${sensorId}/lights-over-threshold-alert-thresholds?from=${convertDate(
    from
  )}&to=${convertDate(to)}`;

  return callApi(url);
};

const getHvacOverThresholdAlertThresholds = (sensorId, from, to) => {
  const convertDate = date =>
    moment(date)
      .utc()
      .format("YYYYMMDDHHmmss");

  const url = `${baseUrl}sensors/${sensorId}/hvac-over-threshold-alert-thresholds?from=${convertDate(
    from
  )}&to=${convertDate(to)}`;

  return callApi(url);
};

const getAlertEventsForSensor = (sensorId, from, to) => {
  const convertDate = date =>
    moment(date)
      .utc()
      .format("YYYYMMDDHHmmss");

  let url = `${baseUrl}sensors/${sensorId}/alertEvents?from=${convertDate(
    from
  )}`;

  if (to) {
    url += `&to=${convertDate(to)}`;
  }

  return callApi(url);
};

export default {
  getData,
  getLightsOverThresholdAlertThrehsolds,
  getHvacOverThresholdAlertThresholds,
  getDataFromDingo,
  getAlertEventsForSensor
};
